import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { APP_ALLOWED_MODULES } from '../config/appConfig';
import { catchError, filter, map } from 'rxjs/operators';
import { IdentityService } from '../services/identity.service';

@Injectable({
    providedIn: 'root',
})
export class CheckAppGuard {
    constructor(private identityService: IdentityService, private router: Router) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UrlTree | boolean> {
        let currentPath = '';

        const currentPathMatches = state.url.match(/\/(.*?)\//);

        if (currentPathMatches) {
            currentPath = currentPathMatches[1];
        }

        if (this.identityService.companyLoaded) {
            return of(this.redirectToProperUrl(currentPath));
        }

        return this.identityService.companyLoaded$.pipe(
            filter((isLoaded) => isLoaded),
            catchError((err) => {
                return throwError(() => err);
            }),
            map(() => {
                return this.redirectToProperUrl(currentPath);
            }),
        );
    }

    public redirectToProperUrl(currentPath: string) {
        const isAllowed = this.identityService.isModuleAvailable(currentPath);
        if (!isAllowed) {
            const defaultModule = APP_ALLOWED_MODULES.find((path) => path.defaultFor?.includes(this.identityService.getPortalType()));

            if (defaultModule) {
                return this.router.parseUrl('/' + defaultModule.name);
            }
        }

        return isAllowed;
    }
}
